module.exports = __webpack_public_path__ + "static/media/8.41010eaf.jpg";